import { IconButton } from 'component/Button/IconButton'
import { Modal } from 'component/Modal'
import { Qr } from 'component/Qr'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { tele2QrModal } from 'page/BasicInferenceScreen/Tele2QrModal/Tele2QrModalStore'
import { store } from 'store/store'

export const Tele2QrModal = observer(() => {
  const { cart_link, item_link } = store.basic
  const link = cart_link || item_link

  const onClose = useLatestCallback(async () => {
    tele2QrModal.close()
  })

  if (!link) return null

  return <Modal gap={0} width={640} round={36}>
    <Space right>
      <IconButton size={64} action={onClose}>
        <Icon size={32} name="close" />
      </IconButton>
    </Space>
    <Space wide center>
      <Qr link={link} size={400} pad={16} />
    </Space>
    <Gap height={48} />
    <Space center>
      <Typo size={24} center balance>
        {cart_link ? i18n('ScanQrCodeItemWillBeAddedToYourCart') : i18n('ScanQrCodeBuyItemInStore')}
      </Typo>
    </Space>
    <Gap height={48} />
  </Modal>
})
